<template>
  <ul class="pagination" :class="paginationClass">
    <li class="page-item prev-page" :class="[{disabled: currentPage === 1}, prevItemClasses]">
      <a class="page-link" aria-label="Previous" @click="prevPage">
        «
      </a>
    </li>
    <li class="page-item"
        v-for="item in range(minPage, maxPage)"
        :key="item"
        :class="[{active: currentPage === item}, itemClasses]">
      <a class="page-link" @click="changePage(item)">{{item}}</a>
    </li>
    <li class="page-item page-pre next-page" :class="[{disabled: currentPage === totalPages}, nextItemClasses]">
      <a class="page-link" aria-label="Next" @click="nextPage">
        »
      </a>
    </li>
  </ul>
</template>
<script>
  import axios from "axios";
  import { Loading } from 'element-ui';
  import {API_ENDPOINT} from '@/constants';

  export default{
    name: 'eventcircle-pagination',
    model: {
      prop: 'currentPage',
    },
    props: {
      type: {
        type: String,
        default: 'primary',
        validator: (currentPage) => {
          return ['default', 'primary', 'danger', 'success', 'warning', 'info'].includes(currentPage)
        }
      },
      pageCount: {
        type: Number,
        default: 0
      },
      perPage: {
        type: Number,
        default: 10
      },
      total: {
        type: Number,
        default: 0
      },
      currentPage: {
        type: Number,
        default: 1
      },
      ids: {
        type: Array,
        default: []
      },
      prevItemClasses: [String, Object],
      itemClasses: [String, Object],
      nextItemClasses: [String, Object]
    },
    computed: {
      paginationClass () {
        return `pagination-${this.type}`
      },
      totalPages () {
        if (this.pageCount > 0) return this.pageCount
        if (this.total > 0) {
          return Math.ceil(this.total / this.perPage)
        }
        return 1
      },
      pagesToDisplay () {
        if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
          return this.totalPages
        }
        return this.defaultPagesToDisplay
      },
      minPage () {
        if (this.currentPage >= this.pagesToDisplay) {
          const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
          const newMaxPage = pagesToAdd + this.currentPage
          if (newMaxPage > this.totalPages) {
            return this.totalPages - this.pagesToDisplay + 1
          }
          return this.currentPage - pagesToAdd
        } else {
          return 1
        }
      },
      maxPage () {
        if (this.currentPage >= this.pagesToDisplay) {
          const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
          const newMaxPage = pagesToAdd + this.currentPage
          if (newMaxPage < this.totalPages) {
            return newMaxPage
          } else {
            return this.totalPages
          }
        } else {
          return this.pagesToDisplay
        }
      }
    },
    data () {
      return {
        defaultPagesToDisplay: 10,
        loadingInstance: null,
        //articles: []
      }
    },
    methods: {
      range (min, max) {
        let arr = []
        for (let i = min; i <= max; i++) {
          arr.push(i)
        }
        return arr
      },
      changePage (item) {
        this.$emit('input', item)
        this.loadingInstance = Loading.service({ fullscreen: true });
        this.pageChangeHandle(item)
      },
      nextPage () {
        if (this.currentPage < this.totalPages) {
          this.$emit('input', this.currentPage + 1)
          this.pageChangeHandle(this.currentPage + 1)
        }
      },
      prevPage () {
        if (this.currentPage > 1) {
          this.$emit('input', this.currentPage - 1)
          this.pageChangeHandle(this.currentPage -1)
        }
      },
      async pageChangeHandle(currentPage) {
          let endpoint = API_ENDPOINT + `organizations/?extract=` + this.ids.join('&extract=') + `&page=${currentPage}`
          await axios.get(endpoint)
            .then(res => {
              this.circles = res.data
              this.$emit('fav', res.data.organizations)
              this.loadingInstance.close();
          })
          .catch(err => {
            console.log(err);
          })
      }
    },
    watch: {
      perPage () {
        this.$emit('input', 1)
      },
      total () {
        this.$emit('input', 1)
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "~@/assets/sass/now-ui-kit/variables";
  @import "~@/assets/sass/now-ui-kit/pagination";
</style>
